<Particles *ngIf="particlesOptions != null" id="tsparticles" [options]="particlesOptions" (particlesLoaded)="particlesLoaded($event)"></Particles>